import { ListItemButton, styled } from '@mui/material';
import { listItemButtonClasses } from '@mui/material/ListItemButton';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { listItemTextClasses } from '@mui/material/ListItemText';

const StyledMainMenuNestedButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: '13px',
  paddingLeft: theme.spacing(4),
  position: 'relative',
  // Velo neutro mode-aware (igual que el menú principal), NO azul.
  '&::before': {
    background: theme.palette.mode === 'light' ? 'rgba(17, 21, 27, 0.06)' : 'rgba(255, 255, 255, 0.08)',
    borderRadius: '13px',
    content: '""',
    display: 'block',
    height: '100%',
    left: 0,
    opacity: 0,
    position: 'absolute',
    top: 0,
    transition: `opacity ${theme.transitions.easing.easeInOut} ${theme.transitions.duration.short}ms`,
    width: '100%'
  },
  [`& .${listItemTextClasses.root}`]: {
    zIndex: 1
  },
  [`& .${listItemIconClasses.root}`]: {
    zIndex: 1
  },
  '&:hover::before': {
    opacity: 1
  },
  // Activo: relleno gris NEUTRO (sin dorado), igual que el menú principal.
  [`&.${listItemButtonClasses.selected}`]: {
    backgroundColor: theme.palette.selected.bg,
    [`& .${listItemTextClasses.root}`]: {
      color: theme.palette.selected.fg
    },
    [`& .${listItemIconClasses.root}`]: {
      color: theme.palette.selected.fg
    },
    '&:hover': {
      backgroundColor: theme.palette.selected.bg
    }
  }
}));

export default StyledMainMenuNestedButton;
